/**
 * Retenciones sufridas: las que nos hace un cliente al pagarnos. Espejo de backend/src/common/retencion-sufrida.ts
 * (ahí están las pruebas): la lista, las etiquetas y la regla de jurisdicción tienen que coincidir.
 */

export const TIPOS_RETENCION_SUFRIDA = ['IIBB', 'IVA', 'GANANCIAS', 'SUSS'] as const;
export type TipoRetencionSufrida = (typeof TIPOS_RETENCION_SUFRIDA)[number];

export const ETIQUETAS_TIPO_RETENCION_SUFRIDA: Record<TipoRetencionSufrida, string> = {
  IIBB: 'Ingresos Brutos',
  IVA: 'IVA',
  GANANCIAS: 'Ganancias',
  SUSS: 'SUSS',
};

export const esTipoRetencionSufrida = (v: unknown): v is TipoRetencionSufrida =>
  typeof v === 'string' && (TIPOS_RETENCION_SUFRIDA as readonly string[]).includes(v);

/** Origen de una fila del informe de sufridas: cargada en Cobros o leída de los pagos de MercadoPago (a verificar). */
export const ORIGENES_RETENCION_SUFRIDA = ['Cliente', 'MercadoPago'] as const;
export type OrigenRetencionSufrida = (typeof ORIGENES_RETENCION_SUFRIDA)[number];

/** Tipo de las retenciones de MercadoPago que no son de IIBB (no se carga a mano). */
export const TIPO_RETENCION_OTRO = 'OTRO';

/** IIBB es provincial: pide jurisdicción. IVA, Ganancias y SUSS son nacionales: no llevan. */
export const requiereJurisdiccion = (tipo: string): boolean => tipo === 'IIBB';

/** Etiqueta para mostrar; el código tal cual si no es de la lista. */
export const etiquetaTipoRetencionSufrida = (tipo: string): string =>
  esTipoRetencionSufrida(tipo) ? ETIQUETAS_TIPO_RETENCION_SUFRIDA[tipo] : tipo === TIPO_RETENCION_OTRO ? 'Otro' : tipo;

/** Suma de las retenciones a centavos (los montos pueden llegar como texto). */
export const totalRetenciones = (retenciones: { monto: number | string }[] | null | undefined): number =>
  Math.round((retenciones ?? []).reduce((s, r) => s + (Number(r.monto) || 0), 0) * 100) / 100;
